import { useIsGlobalLoading } from "@/contexts/GlobalLoadingContext";

/**
 * Indeterminate loading indicator: a thin bar that says something is in
 * flight, and nothing else.
 *
 * It replaces FullPanelLoadingOverlay, which reported loading, covered
 * the whole panel, painted the page's surface (its own comment described
 * it as standing in for the content island) and swallowed pointer events.
 * Bundling the surface into the loading indicator is why a rectangle
 * flashed over every page on every navigation and every fetch: the cover
 * had to be opaque to do the second job, so it could not stop being
 * visible while doing the first.
 *
 * Where the bar sits belongs to whoever renders it, not to the bar.
 */
export function GlobalLoadingBar() {
  const isLoading = useIsGlobalLoading();
  if (!isLoading) return null;

  return (
    <div className="h-0.5 w-full overflow-hidden" role="progressbar" aria-label="Cargando">
      <div className="gradient-flow h-full w-1/3 rounded-full animate-loading-bar [mask-image:linear-gradient(to_right,transparent,black_18%,black_82%,transparent)]" />
    </div>
  );
}
